import { Component, Input, Inject, OnInit } from "@angular/core";
import { RequestLogSet } from "../../../entities/log/request-log.set";
import { HttpClient } from "@angular/common/http";
import { FirebaseAuthService } from "../../../noizu/services/firebase-auth.service";
import { RequestLogRepo } from "../../../repos/log/request-log.repo";
import { DomainObject } from "../../../noizu/domain-object";
import { ToasterService } from "angular2-toaster";
import { DateTimeLogicalWidget } from "../../../entities/logical/date-time-logical.entity";
import { DateTimeIntervalEntity, ModalWidget } from "../../../entities";
import { ModalWidgetEnum } from "../../../enums";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";

@Component({
  selector: "embed-request-logs",
  template: `
    <div class="row">
      <div class="col-12">
        <div class="card border-primary">
          <div class="card-header">
            <div class="row">
              <div class="col-10">
                Request Logs |
                <i
                  class="fa fa-lg fa-2x fa-calendar text-success"
                  (click)="customRange($event, pickerModal)"
                ></i>
              </div>
              <div class="col-2">
                <label
                  class="switch switch-3d switch-primary float-right"
                  *ngIf="load_status"
                >
                  <input
                    (change)="toggleEnabled($event)"
                    class="switch-input"
                    type="checkbox"
                    [(ngModel)]="toggle"
                    name="toggleEnabled"
                  />
                  <span class="switch-slider"></span>
                </label>
              </div>
            </div>
          </div>
          <div class="card-body" *ngIf="entity.enabled">
            <div class="row">
              <div class="col-12 text-center">
                <div class="row mb-2">
                  <div class="col">
                    <input
                      (change)="filterRecords($event)"
                      [(ngModel)]="newFilter"
                      [width]="64"
                      type="text"
                      placeholder="Request Filter"
                      class="col-6 form-control-lg"
                    />
                    <div
                      class="alert alert-warning"
                      *ngIf="entity?.filterOptions()"
                    >
                      Filter Options: {{ entity.filterOptions() }}
                    </div>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col">
                    <input
                      [(ngModel)]="responseKeyFilter"
                      [width]="64"
                      type="text"
                      placeholder="Response Filter"
                      class="col-6 form-control-lg"
                    />
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col text-center">
                    <button
                      *ngIf="!last_to"
                      (click)="fetchLogs($event)"
                      class="btn btn-lg btn-warning"
                      type="submit"
                    >
                      <i
                        class="fa"
                        [ngClass]="{
                          'fa-dot-circle-o': !refreshing,
                          'fa-spinner': refreshing
                        }"
                      ></i>
                      Query
                    </button>
                    <button
                      *ngIf="last_to"
                      (click)="fetchNewerLogs($event)"
                      class="btn btn-lg btn-warning"
                      type="submit"
                    >
                      <i
                        class="fa"
                        [ngClass]="{
                          'fa-arrow-circle-up': !refreshing,
                          'fa-spinner': refreshing
                        }"
                      ></i>
                      Newer
                    </button>
                  </div>
                </div>

                <div class="row" *ngIf="error_code != 0">
                  <div class="col">
                    <div class="alert alert-info">{{ error_message }}</div>
                  </div>
                </div>

                <div
                  class="row"
                  *ngIf="
                    entity?.loaded &&
                    entity.entries.length == 0 &&
                    error_code == 0
                  "
                >
                  <div class="col">
                    <div class="alert alert-info">
                      No records in selected range
                      {{ this.last_from | date: "medium" }} -
                      {{ this.last_to | date: "medium" }}
                    </div>
                  </div>
                </div>

                <div *ngIf="entity?.loaded">
                  <div class="card p-0 m-0">
                    <div class="card-header p-0 m-0">
                      <div class="row align-items-center no-gutters">
                        <div class="col-2 text-left font-weight-bold">
                          Time & Span
                        </div>
                        <div class="col-3 text-left font-weight-bold">
                          Request Category
                        </div>
                        <div class="col-3 text-left font-weight-bold">
                          Report Binary
                        </div>
                        <div class="col-1 font-weight-bold">
                          <span *ngIf="isGateway">Device</span>
                          <span *ngIf="!isGateway">Gateway</span>
                        </div>
                        <div class="col-2 font-weight-bold">Response</div>
                        <div class="col-1 text-center font-weight-bold">
                          Expand/Collapse
                        </div>
                      </div>
                    </div>
                    <div *ngFor="let log of entity.entries; let i = index">
                      <div class="row" *ngIf="log.filter(newFilter)">
                        <div class="col-12 text-left">
                          <log-sub-type-embed
                            [entity]="log"
                            [options]="requestOptionsForLog(log)"
                            [layout]="layout"
                            [isGateway]="isGateway"
                          >
                          </log-sub-type-embed>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-2" *ngIf="last_from">
                    <div class="col text-center">
                      <button
                        (click)="fetchOlderLogs($event)"
                        class="btn btn-lg btn-warning"
                        type="submit"
                      >
                        <i
                          class="fa"
                          [ngClass]="{
                            'fa-arrow-circle-down': !refreshing,
                            'fa-spinner': refreshing
                          }"
                        ></i>
                        More
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #pickerModal>
        <modal-widget
          *ngIf="currentModal"
          (widgetEvent)="eventHandler($event, 'pop-up', pickerModal)"
          [entity]="currentModal"
          [layout]="'shadowbox'"
          [options]="{}"
        ></modal-widget>
      </ng-template>
    </div>
  `,
})
export class EmbedRequestLogsComponent extends DomainObject implements OnInit {
  @Input() entity: RequestLogSet | null = null;
  @Input() options: any = {};
  @Input() layout: string | null = null;
  @Input() isGateway: boolean = false;

  public range_from: DateTimeLogicalWidget;
  public range_to: DateTimeLogicalWidget;
  public repo: RequestLogRepo;
  public refreshing = false;
  public load_status = false;
  public toggle = false;
  public modalRef!: BsModalRef;
  public currentModal: any = null;
  public last_from: any = null;
  public last_to: any = null;
  public error_code = 0;
  public error_message = "";

  public newFilter = "";
  public responseKeyFilter = "";

  constructor(
    @Inject(HttpClient) client: HttpClient,
    @Inject(FirebaseAuthService) auth: FirebaseAuthService,
    public modalService: BsModalService,
    public toasterService: ToasterService,
  ) {
    super(client, auth, []);
    this.repo = new RequestLogRepo(client, auth);
    this.range_from = new DateTimeLogicalWidget(undefined, "24 Hours");
    this.range_to = new DateTimeLogicalWidget(undefined, "Now");
  }

  public filterRecords(event: any) {}

  public requestOptionsForLog(log: any): any {
    return {
      ...(this.options || {}),
      responseKeyFilter: this.responseKeyFilter,
      responseKeyValue: this.getMatchedResponseValue(log),
    };
  }

  public getMatchedResponseValue(log: any): string {
    const query = (this.responseKeyFilter || "").trim().toLowerCase();
    if (!query) return "";

    const value = this.findResponseValue(log?.content?.response_body, query);
    if (value === null || value === undefined) return "";
    return typeof value === "object" ? "obj" : String(value);
  }

  public findResponseValue(value: any, query: string, prefix = ""): any {
    if (value === null || value === undefined) return null;
    if (typeof value !== "object") return null;

    for (const key of Object.keys(value)) {
      const path = prefix ? `${prefix}.${key}` : key;
      if (
        key.toLowerCase().includes(query) ||
        path.toLowerCase().includes(query)
      ) {
        return value[key];
      }

      const nested = this.findResponseValue(value[key], query, path);
      if (nested !== null && nested !== undefined) {
        return nested;
      }
    }

    return null;
  }

  eventHandler(event: any, field: any, modal: any) {
    console.log("Release Unhandled Event", field, event);
  }

  showModal(current: any, modal: any, clickOut = false, customClass = "") {
    this.currentModal = current;
    if (!clickOut) {
      let config: ModalOptions = {
        backdrop: "static",
        keyboard: false,
        class: customClass,
      };
      this.currentModal.modalRef = this.modalService.show(modal, config);
    } else {
      let config: ModalOptions = {
        class: customClass,
      };
      this.currentModal.modalRef = this.modalService.show(modal, config);
    }
  }

  customRange(e: any, modal: any) {
    let to = new Date();
    let from = new Date(to.getTime() - 4 * 60 * 60 * 1000);
    let time_range = new DateTimeIntervalEntity(from, to);
    let dialog = new ModalWidget(
      `Pull Range`,
      ModalWidgetEnum.MODAL_WIDGET__CONFIRM,
      time_range,
      { edit: true },
      "shadowbox",
      time_range.overrides(),
    );
    this.showModal(dialog, modal, false, "md-modal");
    time_range.promise
      .then((r: any) => {
        const to = r.to as Date;
        const from = r.from as Date;
        this.refreshing = true;
        this.repo
          .query(this.entity!.subject, this.entity!.type, from, to)
          .then((set: any) => {
            this.error_code = set.error_code;
            this.error_message = set.error_message;
            this.entity!.entries = this.entity!.entries.concat(
              set.entries,
            ).sort((a, b) => b.time - a.time);
            if (this.error_code == 0) {
              this.last_from = from;
              this.last_to = to;
            } else {
              this.last_from = null;
              this.last_to = null;
            }
            this.entity.loaded = true;
            this.refreshing = false;
          });
      })
      .catch(() => {
        // swallow
      });
  }

  ngOnInit() {
    this.entity!.isLoaded().then((v: any) => {
      this.load_status = true;
      this.toggle = this.entity.enabled;
    });
  }

  toggleEnabled(event: any) {
    event.preventDefault();
    this.entity.toggleEnabled().then((v: boolean) => {
      this.toasterService.pop(
        "info",
        "Request Logs",
        `Request Logs ${v ? "Enabled" : "Disabled"}`,
      );
      this.toggle = v;
    });
  }

  update_last_from_to(from, to) {
    if (!this.last_from) {
      this.last_from = from;
    } else {
      this.last_from = from < this.last_from ? from : this.last_from;
    }

    if (!this.last_to) {
      this.last_to = to;
    } else {
      this.last_to = to > this.last_to ? to : this.last_to;
    }
  }

  fetchLogs(
    event: any,
    from: Date | null = null,
    to: Date | null = null,
    retry = true,
  ) {
    event.preventDefault();
    to = to || new Date();
    from = from || new Date(to.getTime() - 1000 * 60 * 60 * 4);
    //this.toasterService.pop('info', 'Request Logs', `Querying Request Logs ${to} - ${from}`);
    this.refreshing = true;
    this.repo
      .query(this.entity!.subject, this.entity!.type, from, to)
      .then((set: any) => {
        this.error_code = set.error_code;
        this.error_message = set.error_message;
        if (this.error_code == 1022 && retry) {
          const from2 = new Date(to.getTime() - 1000 * 60 * 60 * 1);
          this.fetchLogs(event, from2, to, false);
        } else {
          if (this.error_code == 0) this.update_last_from_to(from, to);
          if (!this.entity!.entries) this.entity!.entries = new Array();
          this.entity!.entries = this.entity!.entries.concat(set.entries).sort(
            (a, b) => b.time - a.time,
          );
          this.entity!.loaded = true;
          this.refreshing = false;
        }
      });
  }

  fetchNewerLogs(event: any) {
    let from = this.last_to;
    let to = new Date(from.getTime() + 1000 * 60 * 60 * 1);
    let now = new Date();
    to = to > now ? now : to;
    this.fetchLogs(event, from, to, false);
  }

  fetchOlderLogs(event: any) {
    let to = this.last_from;
    let from = new Date(to.getTime() - 1000 * 60 * 60 * 1);
    this.fetchLogs(event, from, to, false);
  }
}